










import { genVuexComputeds } from '@/main/pages/editFactory';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { VOZIDLO_DATA_TYPE } from '@/modules/kartoteka/vozidlo/constants';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';

import { ODLOZENE_SERVISNI_CINNOSTI } from './constants';
import { store } from '../../store/edit';

export default EditStoreMixin.extend({
	name: 'OdlozenaServisniCinnost',
	data() {
		return {
			ODLOZENE_SERVISNI_CINNOSTI,
		};
	},
	computed: {
		...genVuexComputeds(store),
	},
	methods: {
		editClick(event: any) {
			openEdit(VOZIDLO_DATA_TYPE.ZAVADA, PageMode.EDIT, { props: true, id: event.data.ID });
		},
	},
});
